import { BIM360Hub } from '../BIM360Hub';
import { BIM360Project } from '../BIM360Project';

export class FrontendBIM360Hub extends BIM360Hub
{
    public async getProjects(): Promise<BIM360Project[]>
    {
        return [];
    }
}
